// extracted by mini-css-extract-plugin
export default {"timeline":"RankingTimeline_timeline__MArSq","tickIcon":"RankingTimeline_tickIcon__b3CqO","shortenedAlumniLetter":"RankingTimeline_shortenedAlumniLetter__DUhXv"};